<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != '' && user_role == 1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{menuData.menu_title}}</div>
                    </div>
                    <!--Forms-->
                    <form>
                        <div class="forms-container">
                            <div class="row no-margin">

                                <div class="col-12 forms-block">

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Title :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input type="text" v-validate="'required'" class="form-control" v-model="title" id="title" placeholder="Enter title" name="title">
                                            <!-- <i v-show="errors.has('title')" class="fa fa-warning"></i> -->
                                            <span v-show="errors.has('title')" class="help is-danger">{{ errors.first('title') }}</span>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Description :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <textarea name="description" id="description" rows="3"
                                                      class="form-control no-resize"
                                                      placeholder="Enter Description"
                                                      v-model="description">
                                            </textarea>
                                            <!-- <div class="requiredstar">*</div> -->
                                        </div>
                                    </div>

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Date :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <div class="input-group">
                                                <date-picker v-validate="'required|date_format:MM/DD/YYYY'" placeholder="MM/DD/YYYY" id="eventDate" name="date" v-model="eventDate" :config="options" aria-describedby="basic-addon1"></date-picker>
                                                <!-- <span class="input-group-text fa fa-calendar" id="basic-addon1"></span> -->
                                            </div>
                                            <!-- <span v-show="errors.has('date')" class="help is-danger">{{ errors.first('date') }}</span> -->
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Upload Document :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <vue-dropzone
                                                ref="dropzone" 
                                                id="dropzone" 
                                                :options="dropzoneOptions"
                                                @vdropzone-success = "uploadEventDocument"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                @vdropzone-error="fileError"
                                                @vdropzone-file-added="fileAdd"
                                                :useCustomSlot=true
                                                >
                                                <div class="dropzone-custom-content">
                                                    <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                    <div class="subtitle">(Select files from your computer.)</div>
                                                </div>
                                            </vue-dropzone>
                                            <!-- <div class="requiredstar">*</div> -->
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label"><span>{{createdText}}</span> By: {{username}}</div>
                                    </div>

                                    <div class="mr-17 pb-2 float-l">
                                        <button type="submit" id="cancelEventDate" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="cancelEventDate()"><span>Cancel</span></button>
                                        <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEvent('save_and_continue')"><span id="saveAndContinueEvent">Save And Continue</span></button>
                                        <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEvent('save')"><span id="createEvent">Save</span></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import {HTTP} from '../http-common.js';
    import {commonMixins} from '../mixins/commonMixins';
    import moment from 'moment';

    Vue.component("vueDropzone", vue2Dropzone);
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);

    export default {
        name: 'SaveDateAddForm',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                createdText: 'Created',
                edit_id: 0,
                eventDate: '',
                options: {
                    format: 'MM/DD/YYYY',
                    //minDate: new Date()
                },
                form_slug: "",
                username: "",
                title: "",
                document: "",
                description: "",
                url: "",
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    }
                },
                /* isFileUploaded: false, */
                eventImagesPaths: [],
                eventImagesType: [],
                eventImagesSize: [],
                loadDocArr: [],
                error: "",
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            //self.getRole();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.username = self.formatString(userJson["first_name"] + " " + userJson["last_name"]);
            }

            self.form_slug = this.$route.params.type;

            self.getMenuDetails(self.form_slug);
            /* Get Role for conditionally provide add/edit feature */
            /*
             setTimeout(function () {
             self.user_role = localStorage.getItem("user_role");
             }, 300);
             */
            /* setTimeout(function () {
             
             var path = window.location.pathname;
             var segments = path.split("/");
             if (segments[3]) {
             self.loadEventDocument(segments[3]);
             $('#createEvent').text('Edit');
             }
             }, 100); */

            this.$nextTick(function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3]) {
                    self.edit_id = segments[3];
                    self.loadEventDocument(segments[3]);
                    $('#createEvent').html('Update');
                    self.createdText = 'Updated';
                }
            })

        },
        methods: {

            cancelEventDate: function () {
                var self = this;
                self.$router.push("/" + self.form_slug);
            },

            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* console.log("File Add"); */
            },

            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
            },

            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },

            removedSelectedFile: function (file, xhr, error) {

                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                this.$refs.dropzone.setOption('maxFiles', null);
                var self = this;
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', null);
                }
                /* if (self.eventImagesPaths.length <= 0) {
                 self.isFileUploaded = false;
                 } */
                if ("manuallyAdded" in file == true) {
                    for (var i = self.eventImagesPaths.length - 1; i >= 0; i--) {
                        if (self.eventImagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.eventImagesPaths[i];
                        }
                    }
                    this.$refs.dropzone.setOption('maxFiles', null);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.eventImagesPaths.length - 1; i >= 0; i--) {

                    if (self.eventImagesPaths[i] === removeFile) {
                        self.eventImagesPaths.splice(i, 1);
                        self.eventImagesType.splice(i, 1);
                        self.eventImagesType.splice(i, 1);
                    }
                }
                this.$refs.dropzone.setOption('maxFiles', null);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
            },

            removeFileFromServer: function (filePath) {

                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
                    data: {
                        filePath: filePath,
                    }
                };
                self.showLoader();
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            self.hideLoader();
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("token");
                                    self.$router.push("/");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            uploadEventDocument: function (file, response) {
                var self = this;
                //console.log(file);
                /* self.isFileUploaded = true; */

                self.eventImagesPaths.push(response.content);
                self.eventImagesType.push(file.type);
                self.eventImagesSize.push(file.size);

                //console.log(self.eventImagesPaths);
                this.$refs.dropzone.setOption('maxFiles', null);
            },

            addEvent: function (type) {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                //alert(self.eventDate);
                var config = {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                };
                var fields = {
                    imagePath: self.eventImagesPaths,
                    imageSize: self.eventImagesSize,
                    imageType: self.eventImagesType,
                    title: self.title,
                    description: self.description,
                    slug: self.form_slug,
                    id: segments[3],
                    eventDate: self.eventDate,
                };
                /* console.log(fields); */

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.showLoader();
                        HTTP.post('store_event', fields, config)
                                .then(function (response) {
                                    /*console.log("File removed successfully");*/
                                    self.hideLoader();
                                    if (response.data.status == "success") {
                                        self.removeAllFiles();
                                        if (type == 'save') {
                                            self.$router.push("/" + self.form_slug);
                                        } else {
                                            self.eventImagesPaths = [];
                                            self.eventImagesSize = [];
                                            self.eventImagesType = [];
                                            self.title = '';
                                            self.description = '';
                                            self.eventDate = '';
                                        }
                                    }
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });
            },

            loadEventDocument: function (id) {

                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        'slug': self.form_slug,
                        'id': id
                    }
                };

                self.showLoader();
                HTTP.get("get_event", config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if (response.data.content != "") {

                                    self.title = response.data.content.title;
                                    self.description = response.data.content.description;
                                    self.eventDate = response.data.content.eventDate;
                                    //self.options.minDate = moment(response.data.content.eventDate).subtract(1, 'days').format("MM/DD/YYYY");
                                    self.loadDocArr = response.data.content.imageURL;
                                    self.uploadManually();
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },

            uploadManually: function (file) {

                var self = this;
                for (var i = 0; i < self.loadDocArr.length; i++) {

                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    var file_type = self.getFileType(self.loadDocArr[i]['type']);
                    var file_size = self.loadDocArr[i]['size'];

                    self.eventImagesType.push(file_type);
                    self.eventImagesSize.push(Number(file_size));

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                }
                /* console.log("Accepted");
                 console.log(this.$refs.dropzone.getAcceptedFiles());
                 console.log("Rejected");
                 console.log(this.$refs.dropzone.getRejectedFiles()); */

                //this.$refs.dropzone.addRemoveLinks = true;
            },

            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2];

                self.eventImagesPaths.push(String(orgPath + "/" + file_name));

                return file_name;
            },

            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/EventAddForm.vue